/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../../../common";
import type {
  GenericNameServiceLogic,
  GenericNameServiceLogicInterface,
} from "../../../../contracts/dependant/nameService/GenericNameServiceLogic";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingle",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
    ],
    name: "getSingleSafe",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isBlocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultiple",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isMultipleSafe",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
    ],
    name: "isPrivileged",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listMultipleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            internalType: "address[]",
            name: "addr",
            type: "address[]",
          },
        ],
        internalType: "struct GenericNameServiceType.MultipleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "listSingleEntries",
    outputs: [
      {
        components: [
          {
            internalType: "bytes32",
            name: "name",
            type: "bytes32",
          },
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
        ],
        internalType: "struct GenericNameServiceType.SingleEntryRet[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newAssociatedOperator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setAssociatedOperator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setBlockList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
    ],
    name: "setMultiple",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
    ],
    name: "setMultipleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "list",
        type: "address[]",
      },
      {
        internalType: "bool",
        name: "flag",
        type: "bool",
      },
    ],
    name: "setPrivilegedList",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "keyName",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "which",
        type: "address",
      },
      {
        internalType: "bool",
        name: "enable",
        type: "bool",
      },
    ],
    name: "setSingle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32[]",
        name: "keyName",
        type: "bytes32[]",
      },
      {
        internalType: "address[]",
        name: "which",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "enable",
        type: "bool[]",
      },
    ],
    name: "setSingleEntries",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type GenericNameServiceLogicConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GenericNameServiceLogicConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class GenericNameServiceLogic__factory extends ContractFactory {
  constructor(...args: GenericNameServiceLogicConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<GenericNameServiceLogic> {
    return super.deploy(overrides || {}) as Promise<GenericNameServiceLogic>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): GenericNameServiceLogic {
    return super.attach(address) as GenericNameServiceLogic;
  }
  override connect(signer: Signer): GenericNameServiceLogic__factory {
    return super.connect(signer) as GenericNameServiceLogic__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GenericNameServiceLogicInterface {
    return new utils.Interface(_abi) as GenericNameServiceLogicInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GenericNameServiceLogic {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as GenericNameServiceLogic;
  }
}
